import * as yup from 'yup'
import { URL_REGEX } from 'utils/constants'

export const kdsConfigSchema = yup.object().shape({
  createOrderUrl: yup
    .string()
    .trim()
    .matches(URL_REGEX, 'Invalid Create/Update Order URL')
    .required('Create/Update Order URL is required'),
  cancelOrderUrl: yup
    .string()
    .trim()
    .matches(URL_REGEX, 'Invalid Cancel Order URL')
    .required('Cancel Order URL is required'),
  username: yup.string().trim().required('Username is required'),
  password: yup.string().trim().required('Password is required'),
  webhookSecret: yup.string().trim().required('Webhook Secret is required'),
  slaMinutes: yup
    .number()
    .typeError('SLA (Minutes) must be a number')
    .required('SLA (Minutes) is required')
    .integer('SLA (Minutes) must be an integer')
    .min(0, 'SLA (Minutes) must be a non-negative integer'),
  isEnabled: yup.boolean().required(),
})

export type KdsConfigFormFields = yup.InferType<typeof kdsConfigSchema>
